// Returns the authoritative master-context markdown for a case (or null if
// none exists). Injected into the system prompt of every AI call so the model
// answers from this record rather than from training-data recall.
//
// Mirrors casebinder-next/src/lib/cases.ts (getCaseContext).

import { JUUL_MASTER_CONTEXT } from '../data/juul/master-context';
import { MUSK_MASTER_CONTEXT } from '../data/musk/master-context';

export function getCaseContext(caseId) {
  switch (caseId) {
    case 'juul':
      return JUUL_MASTER_CONTEXT;
    case 'musk':
      return MUSK_MASTER_CONTEXT;
    default:
      return null;
  }
}
